









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteAnnouncement, QueryAnnouncementList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditAnnouncementDialog from './EditAnnouncementDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditAnnouncementDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '公告标题', param: 'title' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建公告', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '公告标题', param: 'title' },
    { title: '公告内容', param: 'content',  overflow: true},
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo() {
    const d = this.$refs.EditAnnouncementDialog as EditAnnouncementDialog
    d.open({}, false)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteAnnouncement({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public openEditVideo(data: any) {
    const d = this.$refs.EditAnnouncementDialog as EditAnnouncementDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryAnnouncementList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
